__turbopack_context__.v({
  "carrierImg": "TrackingNumber-module__8ptIAq__carrierImg",
  "container": "TrackingNumber-module__8ptIAq__container",
  "imgWrapper": "TrackingNumber-module__8ptIAq__imgWrapper",
  "row": "TrackingNumber-module__8ptIAq__row",
  "trackingNumber": "TrackingNumber-module__8ptIAq__trackingNumber",
});
